module.exports = __webpack_public_path__ + "a43148874f466e3cd4fa70c882a69923.png";